.TextCursorAnimation {
  display: inline-flex;
  align-items: center;
}

.TextCursorAnimation__inner {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.TextCursorAnimation__text {
  font-weight: var(--brand-text-weight-500);
  white-space: pre;
}

.TextCursorAnimation__sizingContainer {
  display: inline-grid;
  clip-path: inset(50%);
}

.TextCursorAnimation__sizingText {
  grid-area: 1 / 1;
}

.TextCursorAnimation__content {
  display: inline-flex;
  align-items: center;
  gap: var(--base-size-6);
}

.TextCursorAnimation__content--animated {
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;
}

.TextCursorAnimation__cursor {
  width: calc(var(--base-size-8) + var(--base-size-2) / 2);
  height: calc(var(--base-size-12) + var(--base-size-2));
  flex: 0 0 calc(var(--base-size-8) + var(--base-size-2) / 2);
  position: relative;
  top: -0.5px; /* optical adjustment*/
}

.TextCursorAnimation__cursor--initial {
  background-color: var(--brand-TextCursorAnimation-cursor-color);
}

.TextCursorAnimation__cursor--animated {
  animation: TextCursorAnimation-cursor-blink var(--brand-TextCursorAnimation-cursor-animationDuration) steps(1, end)
    250ms 3 forwards;
}

.TextCursorAnimation__cursor--correction {
  background-color: var(--brand-TextCursorAnimation-cursor-deleteColor);
}

.TextCursorAnimation__cursor--final,
.TextCursorAnimation__cursor--complete {
  background-color: var(--brand-TextCursorAnimation-cursor-finalColor);
}

@keyframes TextCursorAnimation-cursor-blink {
  0%,
  79% {
    opacity: 1;
  }

  80%,
  99% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .TextCursorAnimation__cursor {
    animation: none;
  }
}
